<template>
    <base-box v-bind="$props" border-radius="large" background-color="grey" v-on="$listeners">
        <template #content>
            <div class="margin-bottom-normal">
                <g-media-object>
                    <template #left>
                        <g-icon name="exclamation-circle" />
                    </template>
                    <template #default>
                        <g-typography tag="p" value="Please verify your account." />
                    </template>
                    <template #right>
                        <button class="button is-small" @click="verifyAccount">Verify Now</button>
                    </template>
                </g-media-object>
            </div>
            <g-typography tag="p" value="This allows you to:" />
            <ul class="points">
                <li>
                    <g-typography value="Manage your shipping address for receiving products." />
                </li>
                <li v-if="accountMakesPayments">
                    <g-typography value="Set up payout methods for receiving payments." />
                </li>
                <li>
                    <g-typography value="Manage your creator accounts for participating in campaigns. " />
                </li>
                <li>
                    <g-typography value="Manage notifications." />
                </li>
                <li v-if="accountMakesPayments">
                    <g-typography value="View your transaction and conversion history." />
                </li>
            </ul>
        </template>
    </base-box>
</template>

<script>
    export default {
        name: 'AccountVerificationWarning',
        computed: {
            accountMakesPayments() {
                return this.$root.account_makes_payments;
            }
        },
        methods: {
            verifyAccount() {
                this.$emit('verify-account');
            }
        }
    };
</script>

<style lang="scss" scoped>
    .margin-bottom-normal {
        margin-bottom: $g-spacing-5;
    }
    .error {
        color: $g-font-color-error;
    }
    ul.points {
        margin-left: $g-spacing-5;
        margin-bottom: 0;
    }
    .warning-icon {
        color: $g-font-color-warning;
    }
</style>
